"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookItem_1 = require("../../core/model/codebook/CodebookItem");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");
/**
 * Tier represents groups of internal products. It forms so called price architecture
 * between internal products and defines levels of quality or brands. For instance, ham
 * with 90% content of meat can not have the same or lower price than ham with 60 % content
 * of meat.
 *
 * @author JMe
 * @author Radek Beran
 */


var Tier =
/*#__PURE__*/
function (_CodebookItem_1$Codeb) {
  _inherits(Tier, _CodebookItem_1$Codeb);

  /**
   * @param id the of the tier
   * @param title the name of the tier
   * @param level position in structure of all tiers
   * @param description the description of the tier
   * @param isDefault
   * @param flags flags of codebook
   */
  function Tier(id, title, level, description, isDefault, flags) {
    var _this;

    _classCallCheck(this, Tier);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tier).call(this, id, title, description, flags));
    _this.id = id;
    _this.title = title;
    _this.level = level;
    _this.description = description;
    _this.isDefault = isDefault;
    _this.flags = flags;
    return _this;
  }

  return Tier;
}(CodebookItem_1.CodebookItem);

exports.Tier = Tier;
/** Name of codebook for generic codebook API, not lookup sequence. */

Tier.CODEBOOK_NAME = 'tiers'; // tslint:disable-next-line:member-ordering

Tier.tierSchema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Tier.name);
  return {
    id: builder.id('id'),
    title: builder.str('title'),
    level: builder.num('level'),
    description: builder.str('description').withDescription({
      multiline: true
    }),
    isDefault: builder.opt(builder.bool('isDefault')),
    flags: builder.listOf(builder.str('flags')),
    externalId: builder.opt(builder.str('externalId'))
  };
}();